module.exports = __webpack_public_path__ + "img/earn-points.96017717.jpg";